import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { FaSearch, FaClock, FaUsers } from 'react-icons/fa'
import TabNavigation from '../components/UI/TabNavigation'
import MessageAlert from '../components/UI/MessageAlert'
import GlassPanel from '../components/UI/GlassPanel'
import SearchTab from '../components/SearchTab'
import RequestsTab from '../components/RequestsTab'
import FriendsTab from '../components/FriendsTab'
import { useFriendsManager } from '../hooks/useFriendsManager'
import { useMessage } from '../hooks/useMessage'

const AddFriend = () => {
    const navigate = useNavigate()
    const [activeTab, setActiveTab] = useState('search')
    const { message, messageType, showMessage } = useMessage()

    const {
        friendRequests,
        sentRequests,
        friends,
        searchResults,
        loading,
        searchLoading,
        searchUsers,
        sendFriendRequest,
        acceptRequest,
        declineRequest,
        removeFriend
    } = useFriendsManager()

    const handleSearch = async (query) => {
        const result = await searchUsers(query)
        if (!result.success) {
            showMessage(result.error, 'error')
        }
    }

    const handleSendRequest = async (userId, message) => {
        const result = await sendFriendRequest(userId, message)
        showMessage(result.message, result.success ? 'success' : 'error')
    }

    const handleAcceptRequest = async (friendshipId) => {
        const result = await acceptRequest(friendshipId)
        showMessage(result.message, result.success ? 'success' : 'error')
    }

    const handleDeclineRequest = async (friendshipId) => {
        const result = await declineRequest(friendshipId)
        showMessage(result.message, result.success ? 'success' : 'error')
    }

    const handleRemoveFriend = async (friendId) => {
        const result = await removeFriend(friendId)
        showMessage(result.message, result.success ? 'success' : 'error')
    }

    const tabs = [
        {
            id: 'search',
            label: 'Find Friends',
            icon: <FaSearch />
        },
        {
            id: 'requests',
            label: 'Friend Requests',
            icon: <FaClock />,
            badge: friendRequests.length > 0 ? friendRequests.length : null
        },
        {
            id: 'friends',
            label: `My Friends (${friends.length})`,
            icon: <FaUsers />
        }
    ]

    return (
        <div className="p-8 max-w-6xl mx-auto">
            <div className="mb-8">
                <h1 className="text-4xl font-bold text-white mb-2">Friends Management</h1>
                <p className="text-gray-300">Connect with friends and manage your social circle</p>
            </div>

            <MessageAlert message={message} type={messageType} />

            <TabNavigation tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />

            <GlassPanel>
                {activeTab === 'search' && (
                    <SearchTab
                        searchResults={searchResults}
                        searchLoading={searchLoading}
                        onSearch={handleSearch}
                        onSendRequest={handleSendRequest}
                        loading={loading}
                    />
                )}

                {activeTab === 'requests' && (
                    <RequestsTab
                        friendRequests={friendRequests}
                        sentRequests={sentRequests}
                        onAccept={handleAcceptRequest}
                        onDecline={handleDeclineRequest}
                        loading={loading}
                    />
                )}

                {activeTab === 'friends' && (
                    <FriendsTab
                        friends={friends}
                        onRemove={handleRemoveFriend}
                        loading={loading}
                    />
                )}
            </GlassPanel>

            {/* Back Button */}
            <div className="mt-8 flex justify-center">
                <button
                    onClick={() => navigate('/home')}
                    className="bg-gray-600/20 hover:bg-gray-600/30 text-gray-300 font-medium py-3 px-8 rounded-xl border border-gray-500/30 hover:border-gray-500/50 transition-all duration-300"
                >
                    Back to Home
                </button>
            </div>
        </div>
    )
}

export default AddFriend